export enum ProjectFinancingType {
  OTHER = 'autre',
  OWN_FUNDS = 'fonds_propres',
  PUBLIC_GRANT = 'subvention_publique',
  BANK_LOAN = 'pret_bancaire',
  PRIVATE_INVESTMENT = 'investissement_prive',
  CROWDFUNDING = 'crowdfunding',
  PUBLIC_PRIVATE_PARTNERSHIP = 'partenariat_public_prive',
  SPONSORSHIP = 'mecenat',
}
